module.exports = __webpack_public_path__ + "images/stickers/pete-happy.ad61d60483a6bdbea532.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-happy.png
// module id = eQnD
// module chunks = 12